import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Tooltip, Input, Typography, Switch } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";
import Map2 from "../Map/Map2";

const { Option } = Select;
const { Title } = Typography;

const TransportInfrastructureDamageForm = props => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [categoryTypes, setCategoryTypes] = useState([]);

    // This component doesn't have a formItemLayout defined in the original,
    // but we'll add it for consistency with the other forms
    const formItemLayout = {
        labelCol: {
            sm: { span: 8 }
        },
        wrapperCol: {
            sm: { span: 16 }
        }
    };

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/transport/enums/damage-categories")
            .then(({ data }) => {
                setCategoryTypes(data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                transportDamageCategory: props.record.damage.transportDamageCategory,
                reachable: props.record.damage.reachable,
                geometry: props.record.damage.geometry,
            });
        }
    }, [props.record.damage, form]);

    const onValuesChange = (changedValues) => {
        form.validateFields(Object.keys(changedValues));
    };

    const onFieldsChange = (changedFields, allFields) => {
        const fieldsError = form.getFieldsError();
        var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
        
        const values = form.getFieldsValue();
        const newDamage = { ...props.record };
        newDamage.damage.transportDamageCategory = elvis(values.transportDamageCategory);
        newDamage.damage.reachable = elvis(values.reachable);
        newDamage.damage.geometry = elvis(values.geometry);
        newDamage.damage.damageClass = props.damageClass;
        newDamage.valid = valid;
        props.parentCallback(newDamage);
    };

    return (
        <Form
            {...formItemLayout}
            form={form}
            onValuesChange={onValuesChange}
            onFieldsChange={onFieldsChange}
            name="infrastructureDamage"
        >
            <Form.Item label="Category" name="transportDamageCategory">
                <Select>
                    {categoryTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('transportEnums.damageCategory.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Reachable" name="reachable" valuePropName="checked">
                <Switch />
            </Form.Item>
            <Form.Item label="Affected Area" name="geometry">
                <Map2 name="area"></Map2>
            </Form.Item>
        </Form>
    );
};

export default TransportInfrastructureDamageForm;